<script setup>
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { useFVStore } from '../../stores/formvibes';
import Notes from './notes/show.vue';
import { CloseBold } from "@element-plus/icons-vue"
import { setToLocalStorage } from "../../stores/utils";
import VueResizable from 'vue-resizable'

const props = defineProps(['row','closeExpand']);

const store= useFVStore();
const handlers = ref([ 'lb', 'l', 'lt']);
const {isPro, columns, generalStates, size, notes } = storeToRefs(store);
const i18n = window.fvGlobalVar?.i18n;
const status = window.fvGlobalVar.entry_status;
const { user_capability: userCapability } = window.fvGlobalVar;
const rowData = ref('');

watch(() =>{
    if(props.row){
        const data = columns.value?.map((col) => {
            const key = col.colKey;
            const { alias } = col;
            const { original } = props.row;
            return {
                key,
                value: props.row[key],
                label: alias,
            };
        });

        if(isPro.value){
            data.push({
                key: 'fv_status',
                label: i18n?.entry_status,
                value:
                    status?.filter((s) => s.key === props?.row?.fv_status)[0]?.value ||
                    i18n?.unread,
            });
        }
        
        data.push({
            key: 'form_id',
            label: 'form_id',
            value: props.row.form_id,
        });
        data.push({
            key: 'form_plugin',
            label: 'form_plugin',
            value: props.row.form_plugin,
        });

        rowData.value = data;
    }
});

const resizeStop = (e) => {
    const width = e.width;
    const height = e.height;
    if (Number(width) <= 400) {
        setToLocalStorage('fv-sidebar', {
            width: 400,
            height: width,
        });
    }
    else{
        setToLocalStorage('fv-sidebar', {
            width: width,
            height: height,
        });
    }
    generalStates.value.size = {
        width: width,
        height: height
    }
    
}
const formatNewLines = (value) => {
    if (!value) return '';
    return String(value).replace(/\n/g, '<br>');
}
</script>
<template>
    <vue-resizable class="fv-side-panel" :active="handlers" height="100%" :width="size.width" style="position: fixed;left: unset;right: 0;z-index: 99999;cursor: unset;" @resize:end="resizeStop">
        <div class="resizable-content" >
            <div class="fv-expand-content-wrapper">
                <el-icon size="20" @click="closeExpand"><CloseBold /></el-icon>
                <div v-if="(isPro && userCapability?.view_fv_note) && notes[row.id].length > 0" class="fv-mt-2">
                    <Notes :row="row" />
                </div>
                <div class="fv-expand-content">
                    <dl>
                        <div v-for="dt in rowData" :key="dt.key" class="fv-expand-row">
                            <dt>
                                {{dt.label}}
                            </dt>
                            <dd>
                                <span v-html="formatNewLines(dt.value)"></span>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </vue-resizable> 
</template>